"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var GridDataHooks;
(function (GridDataHooks) {
    GridDataHooks["container"] = "Grid-container";
    GridDataHooks["item"] = "Grid-item";
})(GridDataHooks = exports.GridDataHooks || (exports.GridDataHooks = {}));
var GridDataKeys;
(function (GridDataKeys) {
    GridDataKeys["itemsPerRow"] = "data-items-per-row";
    GridDataKeys["itemMaxWidth"] = "data-item-max-width";
    GridDataKeys["dividerWidth"] = "data-divider-width";
    GridDataKeys["rowGap"] = "data-row-gap";
    GridDataKeys["columnGap"] = "data-column-gap";
    GridDataKeys["rowSpan"] = "data-row-span";
    GridDataKeys["columnSpan"] = "data-column-span";
    GridDataKeys["maxColumnWidth"] = "data-max-column-width";
    GridDataKeys["minColumnWidth"] = "data-min-column-width";
})(GridDataKeys = exports.GridDataKeys || (exports.GridDataKeys = {}));
//# sourceMappingURL=DataHooks.js.map